const loadScript = (url, callback = () => {}, opt = {}) => {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    if (opt.charset) {
        script.charset = opt.charset;
    }
    if (opt.id) {
        script.id = opt.id;
    }
    if (script.readyState) {
        script.onreadystatechange = function () {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        };
    }
    else {
        script.onload = function () {
            callback();
        };
    }
    script.src = url;
    document.body.appendChild(script);
};
export default loadScript;